import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
    { label: "Coverages", href: "#coverages" },
    { label: "Why PolicyOne", href: "#manifesto" },
    { label: "Insurers", href: "#insurers" },
    { label: "FAQ", href: "#faq" },
];

export const Nav = () => {
    const [open, setOpen] = useState(false);
    return (
        <header data-testid="site-nav" className="fixed top-0 left-0 right-0 z-50 border-b border-line bg-bone/80 backdrop-blur-xl">
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
                <a href="#top" data-testid="nav-logo" className="font-serif text-2xl font-medium tracking-tight">
                    Policy<span className="italic text-clay">One</span>
                    <span className="text-clay">.</span>
                </a>
                <nav className="hidden items-center gap-10 md:flex">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="font-mono text-xs uppercase tracking-[0.2em] text-moss transition-colors duration-300 hover:text-clay"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#quote"
                        data-testid="nav-get-quote-btn"
                        className="rounded-full bg-ink px-6 py-2.5 font-mono text-xs uppercase tracking-[0.2em] text-bone transition-colors duration-300 hover:bg-clay"
                    >
                        Get a Quote
                    </a>
                </nav>
                <button
                    data-testid="nav-mobile-menu-btn"
                    className="md:hidden"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>
            {open && (
                <div data-testid="nav-mobile-menu" className="border-t border-line bg-bone px-6 py-6 md:hidden">
                    <div className="flex flex-col gap-5">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={() => setOpen(false)}
                                className="font-mono text-sm uppercase tracking-[0.2em] text-moss"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#quote"
                            onClick={() => setOpen(false)}
                            data-testid="nav-mobile-get-quote-btn"
                            className="w-fit rounded-full bg-ink px-6 py-2.5 font-mono text-xs uppercase tracking-[0.2em] text-bone"
                        >
                            Get a Quote
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};
